<script setup lang="ts">
import { storeToRefs } from 'pinia';
import { computed, defineAsyncComponent } from 'vue';

import DatePicker from '@/components/DatePicker.vue';
import LoadingComments from '@/components/LoadingComments.vue';
import ResultsTable from '@/components/ResultsTable.vue';
import { useCompetitionStore } from '@/store/useCompetitionStore';
import { useGraphStore } from '@/store/useGraphStore';
import { useResultsStore } from '@/store/useResultsStore';

const TableGraph = defineAsyncComponent(() => import('@/components/TableGraph.vue'));

const competitionStore = useCompetitionStore();
const graphStore = useGraphStore();
const resultsStore = useResultsStore();

const {
  competitions,
  currentCompetition,
  isLoading: isLoadingCompetition,
} = storeToRefs(competitionStore);
const { results, isLoading: isLoadingResults } = storeToRefs(resultsStore);

const competition = computed(() => currentCompetition.value?.label);

const onRowClick = (resultId: string) => {
  graphStore.currentGraph = graphStore.currentGraph === resultId ? null : resultId;
};
</script>

<template>
  <DatePicker v-if="competitions.length" v-bind="{ competitions, currentCompetition }" />

  <ResultsTable
    v-if="competitions.length || results.length"
    v-bind="{ currentCompetition, results }"
    :on-row-click="onRowClick"
  >
    <template #graph="{ resultId }">
      <TableGraph v-if="graphStore.currentGraph === resultId" :result-id="resultId" />
    </template>
  </ResultsTable>
  <LoadingComments v-if="isLoadingCompetition || isLoadingResults" />
  <div
    class="no-results"
    v-if="!isLoadingCompetition && !isLoadingResults && (!results.length || !competitions.length)"
  >
    There are no results <template v-if="competition">for {{ competition }}</template>
  </div>
</template>

<style lang="scss" scoped>
.no-results {
  text-align: center;
}
</style>
